import React from "react";
import DatePicker from "react-datepicker";
import dollor from "../../../assets/icons/dollar.svg";
import InputWithIcon from "../../../components/InputWithIcon";
import percentage from "../../../assets/icons/percentage.svg";

const AddBovHistoryData = ({ handleSubmit, clearError, formData, onSetFormData, error, handleCancel }) => {
  const handleChange = (value, name) => {
    onSetFormData({ ...formData, [name]: value });
  };

  return (
    <form className="py-3" onSubmit={handleSubmit}>
      <div className="flex-1 mt-3">
        <div className="w-[100%]  md:mt-0">
          <label className="dark-H head-4 mb-2">
            Suggested Retail Price 
          </label>
          <InputWithIcon
            icon={dollor}
            type="number"
            min="0"
            placeholder="Write Suggested Retail Price "
            value={formData?.suggested_sale_price}
            onChange={(e) => {
              handleChange(e.target.value, "suggested_sale_price");
              clearError("suggested_sale_price");
            }}
            onWheel={(e) => e.target.blur()}
          />
        </div>
        {error?.suggested_sale_price && <p className="body-S red-D">{error.suggested_sale_price}</p>}
      </div>

      <div className="flex-1 mt-3">
        <div className="w-[100%] mt-6 md:mt-0">
          <label className="dark-H head-4 mb-2">
            BOV Date
          </label>
          <DatePicker
            className="body-N"
            dateFormat="MM/dd/yyyy"
            placeholderText="MM/DD/YYYY"
            maxDate={new Date()}
            selected={formData.bov_date}
            onChange={(date) => {
              clearError("bov_date");
              handleChange(date, "bov_date");
            }}
          />
        </div>
        {error?.bov_date && <p className="body-S red-D">{error.bov_date}</p>}
      </div>

   
     <div className="flex-1 mt-3">
        <div className="w-[100%]  md:mt-0">
          <label className="dark-H head-4 mb-2">
           Suggested Cap Rate
          </label>
          <InputWithIcon
            icon={percentage}
            type="number"
            min="0"
            placeholder="Write Suggested Cap Rate"
            value={formData?.suggested_cap_rate}
            onChange={(e) => {
              handleChange(e.target.value, "suggested_cap_rate");
              clearError("suggested_cap_rate");
            }}
            onWheel={(e) => e.target.blur()}
          />
        </div>
        {error?.suggested_cap_rate && <p className="body-S red-D">{error.suggested_cap_rate}</p>}
      </div>

      <div className="mt-6">
        <button type="submit" className="save-button light-L head-5 w-50 green-bg-H">
          Save
        </button>
        <button type="button" onClick={handleCancel} className="green-H ml-5">
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddBovHistoryData;
